import React from "react"
import PropTypes from "prop-types"
import NavigationLink from "./NavigationLink"

import { Container } from "reactstrap"
import { useTranslation } from "react-i18next"
import { oldRoutes } from "router/old-routes"
import { useScrollToActive } from "hooks/useScrollToActive"
import { scrollToActive } from "helpers/DOM"

import { useSelector } from "react-redux"
import { routes } from "router"

GuideNavigation.propTypes = {
  className: PropTypes.string
}

export default function GuideNavigation({ className }) {
  const { t } = useTranslation()
  const navigationRef = useScrollToActive()
  const { metadata } = useSelector((store) => store.conversations)
  const totalUnviewed = metadata.total_unviewed_messages

  const classes = ["bg-white shadow"]
  if (className) classes.push(className)

  const clickHandler = ({ currentTarget }) => scrollToActive(currentTarget)

  return (
    <nav className={classes.join(" ")}>
      <Container>
        <div className="full-window-scroll" ref={navigationRef}>
          <div className="hstack gap-20 py-10 py-sm-20">
            <NavigationLink
              to={oldRoutes.guideDashboardPath()}
              iconName="Dashboard"
              label={t("guide.navigation.dashboard")}
              onClick={clickHandler}
            />
            <NavigationLink
              to={oldRoutes.guideBookingsPath()}
              iconName="Bookings"
              label={t("guide.navigation.bookings")}
              onClick={clickHandler}
            />
            <NavigationLink
              to={oldRoutes.guideClientsPath()}
              iconName="Customers"
              label={t("guide.navigation.clients")}
              onClick={clickHandler}
            />
            <NavigationLink to={routes.proExperiencesPath()} iconName="Trips" label={t("guide.navigation.trips")} onClick={clickHandler} />
            <NavigationLink to={oldRoutes.guideBoatsPath()} iconName="Boats" label={t("guide.navigation.boats")} onClick={clickHandler} />
            <NavigationLink
              to={oldRoutes.guideMessagesPath()}
              iconName="Messages"
              label={t("guide.navigation.messages")}
              onClick={clickHandler}
              badge={totalUnviewed > 0 && totalUnviewed}
            />
            <NavigationLink
              to={oldRoutes.guideAccountingPath()}
              iconName="Accounting"
              label={t("guide.navigation.accounting")}
              onClick={clickHandler}
            />
            <NavigationLink
              to={oldRoutes.guideMarketingPath()}
              iconName="Marketing"
              label={t("guide.navigation.marketing")}
              onClick={clickHandler}
            />
            {/* <NavigationLink
              to={oldRoutes.guideWeatherPath()}
              iconName="Weather"
              label={t("guide.navigation.weather")}
              onClick={clickHandler}
            /> */}
          </div>
        </div>
      </Container>
    </nav>
  )
}
